function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import PrimaryAction from "../Module/ModuleActionPrimary";
import SecondaryAction from "../Module/ModuleActionbar";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    minHeight: theme.spacing(7),
    userSelect: "none",
    "&[aria-expanded=true]": {
      minHeight: theme.spacing(8)
    }
  },
  primaryAction: {
    display: "flex",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    "& + $content": {
      marginLeft: 0
    }
  },
  actionbar: {
    display: "flex",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  content: {
    display: "flex",
    alignItems: "baseline",
    flexBasis: "100%",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    "&[data-editable=true]:hover": {
      cursor: "pointer"
    },
    "&[data-collapsible=true]:hover": {
      cursor: "pointer"
    }
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    fontWeight: "normal",
    letterSpacing: 0
  },
  description: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "16px",
    fontWeight: "normal",
    letterSpacing: 0,
    opacity: ".6",
    marginLeft: theme.spacing(1)
  }
}));

const SectionHeader = (_ref) => {
  let title = _ref.title,
      _ref$untitled = _ref.untitled,
      untitled = _ref$untitled === void 0 ? "Untitled" : _ref$untitled,
      description = _ref.description,
      editable = _ref.editable,
      collapsible = _ref.collapsible,
      expanded = _ref.expanded,
      onToggle = _ref.onToggle,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "untitled", "description", "editable", "collapsible", "expanded", "onToggle"]);

  const classes = useStyles();
  return React.createElement("header", {
    className: classes.root,
    "aria-expanded": expanded
  }, React.createElement(PrimaryAction, _extends({}, props, {
    collapsible: collapsible,
    expanded: expanded,
    className: classes.primaryAction,
    onToggle: onToggle
  })), React.createElement("div", {
    className: classes.content,
    "data-editable": editable,
    "data-collapsible": collapsible,
    onClick: onToggle
  }, React.createElement(Typography, {
    className: classes.title,
    component: "h2",
    noWrap: true
  }, title || untitled), description && React.createElement(Typography, {
    className: classes.description,
    component: "h3",
    noWrap: true
  }, description)), React.createElement(SecondaryAction, _extends({}, props, {
    className: classes.actionbar
  })));
};

export default SectionHeader;